import { trackStatsEvent } from "../utils/statsAnalytics";
import { Loader2, PlugZap } from "lucide-react";

export default function SocialConnectButton({ platform, onClick, href, disabled = false, loading = false, title }) {
  const className = "inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-[#9146ff] px-4 text-sm font-semibold text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 disabled:cursor-not-allowed disabled:opacity-50";
  const content = <>{loading ? <Loader2 aria-hidden="true" className="h-4 w-4 animate-spin" /> : <PlugZap aria-hidden="true" className="h-4 w-4" />}Connect {platform}</>;
  const handleClick = (event) => {
    trackStatsEvent("stats_connect_click", { platform: platform.toLowerCase() });
    onClick?.(event);
  };
  return href
    ? <a href={href} onClick={handleClick} className={className}>{content}</a>
    : <button type="button" onClick={handleClick} disabled={disabled || loading} aria-busy={loading} title={title} className={className}>{content}</button>;
}
